import { selector } from 'recoil';
import { roomAtom } from './atoms';

export const roomSelector = selector({
	key: 'ROOM_SELECTOR',
	get: ({ get }) => {
		return get(roomAtom);
	},
	set: ({ get, set }, newValue) => {
		const atom = get(roomAtom);
		set(roomAtom, {
			...atom,
			...newValue
		});
	}
});
